"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const thinninghair = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-thinninghair` : '') + (description ? ` desc-thinninghair` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-thinninghair"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-thinninghair"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.68 14.32a.95.95 0 0 1 .8 1.43c-.36.6-.5 1.68-.16 2.6.17.43.44.81.83 1.08.38.27.93.47 1.71.47a3 3 0 0 0 1.73-.47c.4-.27.67-.66.85-1.1.36-.93.24-2.01-.09-2.6a.95.95 0 0 1 0-.9.9.9 0 0 1 .81-.5h8.04a.75.75 0 0 1 0 1.5H16c.25.92.23 2.05-.17 3.05a3.87 3.87 0 0 1-1.39 1.78c-.68.47-1.54.74-2.58.74a4.4 4.4 0 0 1-2.57-.74 3.78 3.78 0 0 1-1.37-1.79c-.38-1-.38-2.12-.1-3.05H.88a.75.75 0 0 1 0-1.5h7.8Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.55 2.22a.28.28 0 0 1 .37.13c.03.07.04.14.01.21a.28.28 0 0 1-.13.17c-.24.12-.47.27-.69.43-3.8 3.26-4.74 8.95-4.82 13.75a4.3 4.3 0 0 0 .07.54.7.7 0 0 1 .05.55.77.77 0 0 1-.38.44.73.73 0 0 1-.58.05.72.72 0 0 1-.43-.37c-.08-.16-.1-.3-.12-.4l-.04-.28a5.83 5.83 0 0 1-.02-.5c.4-5.25 1.58-10.86 5.92-14.28.25-.16.52-.31.79-.44Z",
    fill: "#232323"
  }));
};
var _default = exports.default = thinninghair;